import { authenticationService } from "~/services";

export function isPartnerKpiOnlyUser() {
  return authenticationService?.currentUserInfo?.roles?.includes("RAN_KPI_ONLY") ?? false;
}

export function shouldHidePartnerKpiField(field: string) {
  if (!isPartnerKpiOnlyUser()) return false;

  const hiddenFields = new Set([
    "siteLocation",
    "siteAttributes",
    "siteTac",
    "radioLocation",
    "radioLocationSyncMode",
    "radioClockPool",
    "radioHeight",
    "radioSas",
    "radioMobility",
    "radioAdvanced",
    "radioInstallation",
    "radioCellFrequency",
    // "radioGroupType",
    "radioGroupPhase",
    "radioGroupFloor",
    "radioGroupArea",
    "radioGroupLocationSyncMode",
    "radioGroupClockPool",
    "radioGroupMap",
    "radioGroupMobility",
    "radioGroupSas",
    "radioGroupFrequency",
    "radioGroupFloorPlan",
  ]);

  return hiddenFields.has(field);
}

// Whitelisted keys for KPI-only create/edit payloads. Whitelist (rather than
// blacklist) so new schema fields default to "not sent" and don't quietly leak
// hidden-section defaults to the backend. `id` and `docVersion` are mandatory
// on edit (PUT URL routing + optimistic concurrency control) and harmless on
// create (id is the client-generated uuid; docVersion is undefined and skipped).
const KPI_ONLY_RADIO_GROUP_ALLOWED_FIELDS = [
  "id",
  "docVersion",
  "name",
  "description",
  "radioSite",
  "zoneType",
] as const;

export function pickKpiOnlyRadioGroupPayload<T extends Record<string, any>>(rg: T): T {
  if (!isPartnerKpiOnlyUser()) return rg;
  const picked: Record<string, any> = {};
  for (const f of KPI_ONLY_RADIO_GROUP_ALLOWED_FIELDS) {
    if (rg[f] !== undefined) picked[f] = rg[f];
  }
  return picked as T;
}

const KPI_ONLY_SITE_ALLOWED_FIELDS = [
  "id",
  "docVersion",
  "name",
  "description",
  "timezone",
] as const;

export function pickKpiOnlySitePayload<T extends Record<string, any>>(site: T): T {
  if (!isPartnerKpiOnlyUser()) return site;
  const picked: Record<string, any> = {};
  for (const f of KPI_ONLY_SITE_ALLOWED_FIELDS) {
    if (site[f] !== undefined) picked[f] = site[f];
  }
  return picked as T;
}
